import { Button, IconButton, TextField } from '@material-ui/core'
import { useFormik } from 'formik'
import { Box } from 'reoil'
import {PracticeExperienceItem} from '../../hooks/api/useFechResume'
import { SubTitle } from '../../pages/UserResumeEditPage'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { useThemeValue } from '../../store/themeState'
import { rgba } from 'polished'
import { MdAdd, MdDelete } from 'react-icons/md'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import dateUtils from '@date-io/dayjs'
import localZh from 'dayjs/locale/zh'


interface PracticeExperienceListProps {
  practiceExperienceList: PracticeExperienceItem[]
  onBlur: (values:PracticeExperienceItem[])=>void
}

const PracticeExperienceList: React.FC<PracticeExperienceListProps> = ({practiceExperienceList=[], onBlur}) => {
  const theme = useThemeValue()

  const formik = useFormik({
    initialValues: practiceExperienceList,
    validate: values=>{
      onBlur(values)
    },
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: values=>{

    }
  })

  const handleClickAdd = ()=> {
    formik.setValues(values=>values.concat({
      organizationName: '',
      positionName: '',
      fromdate: '',
      todate: '',
      experience: '',
      // awards: '',
      userid: '',
      sort: ''
    }))
  }

  const handleClickClose = (index: number)=>{
    formik.setFormikState(form=>{
      delete form.values[index]

      return {
        ...form,
        values: form.values.filter(item=>item)
      }
    })
  }

  return (
    <MuiPickersUtilsProvider utils={dateUtils} locale={localZh}>
      <Box
        className='PracticeExperienceList'
        stretch
        mb={3}
        css={css`
          .series span {
            transform-origin: left top;
            transform: scale(3.6);
          }
          .field {
            margin-bottom: 8px;
          }
        `}>
        <SubTitle xuantian>实践（工作）经历</SubTitle>

        {formik.values && formik.values.map((item, i) => (
          <Box
            className='part'
            key={i}
            border='divider'
            borderRadius={8}
            p={2}
            mb={3}
            stretch>
            <Box
              className='series'
              fontWeight='bold'
              fontSize={1}
              color={rgba(theme.colors.primary, 0.16)}
              mb={1}>
              <span>{i+1}</span>
            </Box>
            <Box position='absolute' style={{zIndex: 2}} right={0} onClick={()=>handleClickClose(i)}><IconButton className="close"><MdDelete/></IconButton></Box>
            <TextField className='field' label='机构/项目名称' name={`[${i}].organizationName`} value={item.organizationName||''} onChange={formik.handleChange} onBlur={formik.handleBlur} />
            <DatePicker className='field' label='开始日期' cancelLabel='取消' okLabel='确定' openTo='year' format='YYYY-MM-DD' name={`[${i}].fromdate`} value={item.fromdate||null} onChange={(date)=>formik.setFieldValue(`[${i}].fromdate`, date?.format('YYYY-MM-DD'))} onBlur={formik.handleBlur} />
            <DatePicker className='field' label='结束日期' cancelLabel='取消' okLabel='确定' openTo='year' format='YYYY-MM-DD' name={`[${i}].todate`} value={item.todate||null} onChange={(date)=>formik.setFieldValue(`[${i}].todate`, date?.format('YYYY-MM-DD'))} onBlur={formik.handleBlur} />
            <TextField className='field' label='工作岗位' name={`[${i}].positionName`} value={item.positionName||''} onChange={formik.handleChange} onBlur={formik.handleBlur} />
            <TextField className='field' label='实践（工作）经历描述' multiline name={`[${i}].experience`} value={item.experience||''} onChange={formik.handleChange} onBlur={formik.handleBlur} />
            {/* <TextField className='field' label='获奖情况' name={`[${i}].awards`} value={item.awards||''} onChange={formik.handleChange} onBlur={formik.handleBlur} /> */}
          </Box>
        ))}

        <Button variant='contained' onClick={handleClickAdd}><MdAdd size={20} />新增</Button>
      </Box>
    </MuiPickersUtilsProvider>
  )
}


export default PracticeExperienceList
